import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form, Col, Row, Table } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { BASE_URL } from "../../../services/Api";
import { authHeader } from "../../../services/auth-header";

const AraiMfgQuoationConversion = ({ enquiryData }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerSearch, setCustomerSearch] = useState(encodeURIComponent(" "));
  const [productOptions, setProductOptions] = useState([]);
  const [productSearch, setProductSearch] = useState(encodeURIComponent(" "));
  const [customerDetailsOptions, setCustomerDetailsOptions] = useState();

  const [enquiryDetails, setEnquiryDetails] = useState({
    quotationtype: "Manufacturing",
    quotationcategory: "International",
    quotationdate: "",
    enquiryrefno: "",
    enquiryrefdate: "",
    customer: "",
    contactperson: "",
    contactno: "",
    email: "",
    customeraddress: "",
    deliveryterm: "",
    incoterms: "",
    paymentterm: "",
    freight: "",
    quotevalidity: "",
    quotationItems: [],
    grandtotalinr: "",
    grandtotalcurrency: "",
  });

  const [customerNameValue, setCustomerNameValue] = useState({ value: enquiryData?.customer?.id, label: enquiryData?.customer?.companyname });
  const [customerAddressValue, setCustomerAddressValue] = useState({ value: enquiryData?.customeraddress?.id, label: enquiryData?.customeraddress?.customeraddress });

  console.log(enquiryData);

  useEffect(() => {
    const ans = enquiryData.enquiryItems.map((item) => ({
      product: {
        id: item?.product?.id,
      },
      description: item?.product?.description,
      productremarks: item?.productremarks,
      itemcode: item?.product?.itemcode,
      hsnsacno: item?.product?.hsnsacno,
      tagnumber: item?.tagnumber,
      modelnumber: item?.modelnumber,
      serialnumber: item?.serialnumber,
      moc: item?.moc,
      partno: item?.partno,
      uom: item.uom,
      quantity: item.quantity,
      unitrateinr: "",
      totalinr: "",
      currency: item.currency,
      exchangerate: "",
      unitratecurrency: "",
      totalcurrency: "",
    }));

    setEnquiryDetails({
      ...enquiryDetails,
      quotationdate: enquiryData?.quotationdate,
      enquiryrefno: enquiryData?.enquiryno,
      enquiryrefdate: enquiryData?.enquirydate,
      customer: {
        id: enquiryData?.customer?.id,
      },
      contactperson: enquiryData?.contactperson,
      contactno: enquiryData?.contactno,
      email: enquiryData?.email,
      customeraddress: {
        id: enquiryData?.customeraddress?.id,
      },
      deliveryterm: enquiryData?.deliveryterm,
      incoterms: enquiryData?.incoterms,
      paymentterm: enquiryData?.paymentterm,
      freight: enquiryData?.freight,
      quotevalidity: enquiryData?.quotevalidity,
      quotationItems: ans,
      grandtotalinr: "",
      grandtotalcurrency: "",
      quotationcurrency: enquiryData?.enquirycurrency,
      quotationexchangerate: "",
    });

    getCustomerAddress(enquiryData.customer.id);
  }, []);

  async function getCustomerData() {
    try {
      const response = await axios.get(`${BASE_URL}customer/page/0/10/asc/id/${customerSearch.length > 0 ? customerSearch : encodeURIComponent(" ")}`, {
        headers: authHeader(),
      });
      setCustomerOptions(
        response.data.Index
          ? response.data.Index.map((customer) => ({
            value: customer.id,
            label: customer.companyname,
          }))
          : response.data.data.map((customer) => ({
            value: customer.id,
            label: customer.companyname,
          }))
      );
    } catch (error) {
      console.log(error);
    }
  }

  async function getProductData() {
    try {
      const response = await axios.get(`${BASE_URL}product/page/international mfg/0/10/asc/id/${productSearch.length > 0 ? productSearch : encodeURIComponent(" ")}`, {
        headers: authHeader(),
      });

      setProductOptions(
        response.data.Index
          ? response.data.Index.map((product) => ({
            value: product.id,
            label: product.description,
          }))
          : response.data.data.map((product) => ({
            value: product.id,
            label: product.description,
          }))
      );
    } catch (error) {
      console.log(error);
    }
  }

  async function getCustomerDetails(id) {
    try {
      const response = await axios.get(`${BASE_URL}customer/findById/${id}`, {
        headers: authHeader(),
      });
      setEnquiryDetails({
        ...enquiryDetails,
        customer: {
          id: id,
        },
        contactperson: response.data.contactperson,
        contactno: response.data.contactno,
        email: response.data.email,
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function getCustomerAddress(id) {
    try {
      const response = await axios.get(`${BASE_URL}customerMultipleAddress/getAddress/${id}`, {
        headers: authHeader(),
      });

      console.log(response);
      setCustomerDetailsOptions(response.data.map((data) => ({ value: data.id, label: data.customeraddress })));
    } catch (error) { }
  }

  async function handleProductChange(event) {
    try {
      const response = await axios.get(`${BASE_URL}product/findById/${event.value}`, {
        headers: authHeader(),
      });

      console.log(response);

      let row = {
        product: {
          id: response.data.id,
        },
        description: response.data.description,
        productremarks: "",
        itemcode: response.data.itemcode,
        hsnsacno: response.data.hsnsacno,
        tagnumber: response.data.tagnumber,
        modelnumber: response.data.modelnumber,
        serialnumber: response.data.serialnumber,
        moc: response.data.moc,
        partno: response.data.partno,
        uom: response.data.unitofmeasurement,
        quantity: "",
        unitrateinr: "",
        totalinr: "",
        currency: enquiryDetails?.quotationcurrency,
        exchangerate: enquiryDetails?.quotationexchangerate,
        unitratecurrency: "",
        totalcurrency: "",
      };

      setEnquiryDetails({
        ...enquiryDetails,
        quotationItems: [...enquiryDetails.quotationItems, row],
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();

    try {
      const response = await axios.post(`${BASE_URL}quotation/enquirytoquotation/${id}`, enquiryDetails, {
        headers: authHeader(),
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Enquiry successfully converted to quotation!",
      });

      navigate("/quotationIndexTable/1");
    } catch (error) {
      console.log(error);
    }
  }

  const calculationsBasedOnExchangeRate = () => {
    let rows = enquiryDetails.quotationItems;

    for (let i = 0; i < enquiryDetails.quotationItems.length; i++) {
      rows[i].unitrateinr = roundToDecimalPlaces(rows[i].unitratecurrency * rows[i].exchangerate, 2);
      rows[i].totalinr = roundToDecimalPlaces(rows[i].unitrateinr * rows[i].quantity, 2);
    }

    setEnquiryDetails({
      ...enquiryDetails,
      quotationItems: rows,
    });

    handleGrandTotal();
  };

  const handleFormChange = (event, element) => {
    if (element === "quotationexchangerate") {
      let data = enquiryDetails;
      data.quotationexchangerate = event.target.value;
      const newItems = enquiryDetails.quotationItems.map((item) => ({
        ...item,
        exchangerate: event.target.value,
      }));

      data.quotationItems = newItems;
      console.log("start");
      setEnquiryDetails(data);
      console.log("start");
      calculationsBasedOnExchangeRate();
      return;
    }

    if (element === "quotationcurrency") {
      const newItems = enquiryDetails.quotationItems.map((item) => ({
        ...item,
        currency: event.target.value, // Update currency for each item
      }));

      setEnquiryDetails({
        ...enquiryDetails,
        quotationcurrency: event.target.value, // Update selected currency
        quotationItems: newItems, // Update all item currencies
      });
      return;
    }
    if (element === "manufacturedby") {
      setEnquiryDetails({
        ...enquiryDetails,
        manufacturedby: event.value,
      });

      return;
    }

    if (element === "customer") {
      getCustomerDetails(event.value);
      getCustomerAddress(event.value);
      setCustomerNameValue(event);
      setCustomerAddressValue("");
      return;
    }

    if (element === "customeraddress") {
      setEnquiryDetails({
        ...enquiryDetails,
        customeraddress: {
          id: event.value,
        },
      });

      setCustomerAddressValue(event);
      return;
    }

    const { name, value } = event.target;
    setEnquiryDetails({
      ...enquiryDetails,
      [name]: value,
    });
  };

  const handleQuantityChange = (event, index) => {
    let rows = enquiryDetails.quotationItems;

    rows[index].quantity = event.target.value;
    rows[index].totalcurrency = roundToDecimalPlaces(Number(rows[index].quantity) * Number(rows[index].unitratecurrency), 2);
    rows[index].totalinr = roundToDecimalPlaces(Number(rows[index].quantity) * Number(rows[index].unitrateinr), 2);

    setEnquiryDetails({
      ...enquiryDetails,
      quotationItems: rows,
    });
    handleGrandTotal();
  };

  const handleUnitRateChange = (event, index) => {
    let rows = enquiryDetails.quotationItems;

    rows[index].unitrateinr = event.target.value;
    rows[index].amount = roundToDecimalPlaces(Number(rows[index].quantity) * Number(rows[index].unitrateinr), 2);
    const gstAmount = (rows[index].amount * Number(rows[index].gst)) / 100; // Calculate GST as a percentage of the amount
    rows[index].totalinr = rows[index].amount + gstAmount;
    rows[index].totalinr = roundToDecimalPlaces(rows[index].totalinr, 2);

    setEnquiryDetails({
      ...enquiryDetails,
      quotationItems: rows,
    });

    handleGrandTotal();
  };

  const handleGrandTotal = (items = enquiryDetails.quotationItems) => {
    let grandTotal = 0;

    for (let i = 0; i < items.length; i++) {
      grandTotal += Number(items[i].totalinr);
    }

    let finalTotal = roundToDecimalPlaces(grandTotal, 2);

    setEnquiryDetails((prevDetails) => ({
      ...prevDetails,
      grandtotalinr: finalTotal,
    }));

    handleGrandTotalCurrency();
  };

  const handleGrandTotalCurrency = (items = enquiryDetails.quotationItems) => {
    let grandTotal = 0;

    for (let i = 0; i < items.length; i++) {
      grandTotal += Number(items[i].totalcurrency);
    }

    let finalTotal = roundToDecimalPlaces(grandTotal, 2);

    setEnquiryDetails((prevDetails) => ({
      ...prevDetails,
      grandtotalcurrency: finalTotal,
    }));
  };

  function handleUnitRateCurrencyChange(event, index) {
    let rows = enquiryDetails.quotationItems;

    rows[index].unitratecurrency = event.target.value;
    rows[index].totalcurrency = roundToDecimalPlaces(Number(rows[index].quantity) * Number(rows[index].unitratecurrency), 2);
    rows[index].unitrateinr = roundToDecimalPlaces(Number(rows[index].unitratecurrency) * Number(rows[index].exchangerate), 2);
    rows[index].totalinr = roundToDecimalPlaces(Number(rows[index].unitrateinr * rows[index].quantity), 2);

    let grandTotal = 0;

    for (let i = 0; i < rows.length; i++) {
      grandTotal += Number(rows[i].totalinr);
    }

    let finalTotal = roundToDecimalPlaces(grandTotal, 2);

    setEnquiryDetails({
      ...enquiryDetails,
      grandtotalinr: finalTotal,
      quotationItems: rows,
    });

    handleGrandTotalCurrency();
  }

  function handleExchangeRate(event, index) {
    let rows = enquiryDetails.quotationItems;

    rows[index].exchangerate = event.target.value;
    let cal = Number(rows[index].exchangerate) * Number(rows[index].unitratecurrency);
    rows[index].unitrateinr = roundToDecimalPlaces(cal, 2);
    let val = Number(rows[index].unitrateinr) * Number(rows[index].quantity);
    rows[index].totalinr = roundToDecimalPlaces(val, 2);

    setEnquiryDetails({
      ...enquiryDetails,
      quotationItems: rows,
    });

    handleGrandTotal();
  }

  function roundToDecimalPlaces(value, decimalPlaces) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(value * factor) / factor;
  }

  const removeRow = (idx) => {
    // Filter out the item at the specified index
    const newItems = enquiryDetails.quotationItems.filter((_, index) => index !== idx);

    // Update state with the new items
    setEnquiryDetails((prevDetails) => ({
      ...prevDetails,
      quotationItems: newItems,
    }));

    // Call handleGrandTotal to recalculate the grand total
    handleGrandTotal(newItems);
    handleGrandTotalCurrency(newItems); // Pass the updated items
  };

  useEffect(() => {
    getCustomerData();
    getProductData();
  }, []);

  useEffect(() => {
    getCustomerData();
  }, [customerSearch]);

  useEffect(() => {
    getProductData();
  }, [productSearch]);

  console.log(enquiryDetails);

  return (
    <div className="container">
      <br></br>

      <Form>
        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Quotation No.</Form.Label>
              <Form.Control disabled type="text" name="quotationno" value={enquiryDetails.quotationno} onChange={handleFormChange} />
            </Form.Group>
          </Col>
          <Col md="6">
            <Form.Group>
              <Form.Label>Quotation Date</Form.Label>
              <Form.Control type="date" name="quotationdate" value={enquiryDetails.quotationdate} onChange={handleFormChange} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Enquiry Ref No.</Form.Label>
              <Form.Control disabled type="text" name="enquiryrefno" value={enquiryDetails.enquiryrefno} onChange={handleFormChange} placeholder="Enquiry Ref No." />
            </Form.Group>
          </Col>
          <Col md="6">
            <Form.Group>
              <Form.Label>Enquiry Ref Date</Form.Label>
              <Form.Control type="date" name="enquiryrefdate" value={enquiryDetails.enquiryrefdate} onChange={handleFormChange} />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Customer Name</Form.Label>
              <Select
                isDisabled
                value={customerNameValue}
                options={customerOptions}
                onChange={(event) => handleFormChange(event, "customer")}
                onInputChange={(event) => {
                  setCustomerSearch(event);
                }}
              />
            </Form.Group>
          </Col>
          <Col md="6">
            <Form.Group>
              <Form.Label>Contact Person</Form.Label>
              <Form.Control value={enquiryDetails.contactperson} disabled />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Contact Number</Form.Label>
              <Form.Control value={enquiryDetails.contactno} disabled />
            </Form.Group>
          </Col>
          <Col md="6">
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control value={enquiryDetails.email} disabled />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Payment Terms</Form.Label>
              <Form.Control disabled type="text" name="paymentterm" value={enquiryDetails.paymentterm} onChange={handleFormChange} placeholder="Payment Terms" />
            </Form.Group>
          </Col>
          <Col md="6">
            <Form.Group>
              <Form.Label>Customer Address</Form.Label>
              <Select value={customerAddressValue} options={customerDetailsOptions} onChange={(event) => handleFormChange(event, "customeraddress")} />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Delivery Terms</Form.Label>
              <Form.Control type="text" name="deliveryterm" value={enquiryDetails.deliveryterm} onChange={handleFormChange} placeholder="Delivery Terms" />
            </Form.Group>
          </Col>
          <Col md="6">
            <Form.Group>
              <Form.Label>Inco Terms</Form.Label>
              <Form.Control type="text" name="incoterms" value={enquiryDetails.incoterms} onChange={handleFormChange} placeholder="Inco Terms" />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Quote Validity</Form.Label>
              <Form.Control type="text" name="quotevalidity" value={enquiryDetails.quotevalidity} onChange={handleFormChange} placeholder="Quote Validity" />
            </Form.Group>
          </Col>
          <Col md="6">
            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Control disabled type="text" name="status" value={enquiryDetails.status} onChange={handleFormChange} placeholder="Status" />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Currency</Form.Label>
              <Form.Select onChange={(e) => handleFormChange(e, "quotationcurrency")} name="quotationcurrency" value={enquiryDetails.quotationcurrency}>
                <option>Select Currency</option>
                <option value="$ (USD)">$ (USD)</option>
                <option value="Euro (Eurpeen Dollar)">Euro (Eurpeen Dollar)</option>
                <option value="GBP (Pounds)">GBP (Pounds)</option>
                <option value="JPY (Japanese Yen)">JPY (Japanese Yen)</option>
                <option value="₹ (INR)">₹ (INR)</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md="6">
            <Form.Group>
              <Form.Label>Exchange Rate (Rs)/Currency</Form.Label>
              <Form.Control type="number" onChange={(e) => handleFormChange(e, "quotationexchangerate")} value={enquiryDetails.quotationexchangerate} name="quotationexchangerate" />
            </Form.Group>
          </Col>
        </Row>

        <br></br>
        <hr></hr>

        <Row>
          <Col md="12">
            <Form.Group>
              <Form.Label>Product</Form.Label>
              <Select
                options={productOptions}
                onChange={handleProductChange}
                onInputChange={(event) => {
                  setProductSearch(event);
                }}
                value=""
              />
            </Form.Group>
          </Col>
        </Row>

        <br></br>
        <div className="table-responsive">
          <Table>
            <thead>
              <tr>
                <th>Product Description</th>
                <th>Product Code</th>
                <th>HSN Code</th>
                <th>Tag No.</th>
                <th>Model No.</th>
                <th>Serial No.</th>
                <th>Part No.</th>
                <th>MOC</th>
                <th>unit of measurement</th>
                <th>Currency</th>
                <th>Quantity</th>
                <th>Unit Rate (Currency)</th>
                <th>Total (Currency)</th>
                <th>Exchange Rate (Rs)/ Currency</th>
                <th>Unit Rate (Rs)</th>
                <th>Total (Rs)</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {enquiryDetails.quotationItems.map((item, index) => (
                <tr key={index}>
                  <td>
                    {item.description}
                    <Form.Control
                      as="textarea"
                      rows={2}
                      className="remarks"
                      type="text"
                      value={item.productremarks}
                      onChange={(e) => {
                        const newRows = [...enquiryDetails.quotationItems];
                        newRows[index].productremarks = e.target.value;
                        setEnquiryDetails({ ...enquiryDetails, quotationItems: newRows });
                      }}
                      placeholder="Enter item remarks"
                      contentEditable="true"
                    />
                  </td>
                  <td>{item.itemcode}</td>
                  <td>{item.hsnsacno}</td>
                  <td>{item.tagnumber}</td>
                  <td>{item.modelnumber}</td>
                  <td>{item.serialnumber}</td>
                  <td>{item.partno}</td>
                  <td>{item.moc}</td>
                  <td>
                    <Form.Select
                      className="uom"
                      value={item.uom ? item.uom.toLowerCase() : ""}
                      onChange={(event) => {
                        // Update the unit of measurement in the respective item
                        const newItems = [...enquiryDetails.quotationItems];
                        newItems[index].uom = event.target.value; // Store the selected value as is
                        setEnquiryDetails({ ...enquiryDetails, quotationItems: newItems });
                      }}
                    >
                      <option value="">Select UOM</option>
                      <option value="bot (bottle)">Bot (Bottle)</option>
                      <option value="ctn (carton)">Ctn (Carton)</option>
                      <option value="days">Days</option>
                      <option value="ft (feet)">Ft (FEET)</option>
                      <option value="hrs (hour)">Hrs (Hour)</option>
                      <option value="kg (kilogram)">Kg (Kilogram)</option>
                      <option value="kgs.">Kgs.</option>
                      <option value="ltr (littre)">Ltr (Littre)</option>
                      <option value="mtr">Mtr</option>
                      <option value="nos (number)">Nos (Number)</option>
                      <option value="pil (pail)">Pil (Pail)</option>
                      <option value="pkt (packet)">Pkt (Packet)</option>
                      <option value="set (sets)">Set (Sets)</option>
                      <option value="pcs (pcs)">Pcs (Pcs)</option>
                    </Form.Select>
                  </td>

                  <td>
                    <Form.Select
                      className="uom"
                      value={item.currency}
                      disabled
                      onChange={(event) => {
                        // Update the unitofmeasurement in the respective item
                        const newItems = [...enquiryDetails.quotationItems];
                        newItems[index].currency = event.target.value;
                        setEnquiryDetails({ ...enquiryDetails, quotationItems: newItems });
                      }}
                    >
                      <option>Select Currency</option>
                      <option value="$ (USD)">$ (USD)</option>
                      <option value="Euro (Eurpeen Dollar)">Euro (Eurpeen Dollar)</option>
                      <option value="GBP (Pounds)">GBP (Pounds)</option>
                      <option value="JPY (Japanese Yen)">JPY (Japanese Yen)</option>
                      <option value="₹ (INR)">₹ (INR)</option>
                    </Form.Select>
                  </td>
                  <td>
                    <Form.Control className="uom" value={item.quantity} min="0" type="number" onChange={(event) => handleQuantityChange(event, index)} />
                  </td>

                  <td>
                    <Form.Control className="uom" min="0" type="number" onChange={(event) => handleUnitRateCurrencyChange(event, index)} value={item.unitratecurrency} />
                  </td>

                  <td>
                    <Form.Control className="uom" min="0" type="text" disabled value={item.totalcurrency} />
                  </td>

                  <td>
                    <Form.Control disabled className="uom" min="0" type="number" value={item.exchangerate} onChange={(event) => handleExchangeRate(event, index)} />
                  </td>

                  <td>
                    <Form.Control className="uom" min="0" type="text" value={item.unitrateinr} disabled onChange={(event) => handleUnitRateChange(event, index)} />
                  </td>

                  <td>
                    <Form.Control disabled className="uom" min="0" type="text" disabled value={item.totalinr} />
                  </td>

                  <td>
                    <IoMdClose onClick={() => removeRow(index)} style={{ cursor: "pointer", color: "red" }} />
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td style={{ fontWeight: "700" }}>Grand Total (Currency)</td>
                <td>
                  <Form.Control min="0" type="number" disabled value={enquiryDetails.grandtotalcurrency} />
                </td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td style={{ fontWeight: "700" }}>Grand Total (Rs)</td>
                <td>
                  <Form.Control min="0" type="number" disabled value={enquiryDetails.grandtotalinr} />
                </td>
                <td></td>
              </tr>
            </tfoot>
          </Table>
        </div>
        <button className="button-70" type="button" onClick={handleSubmit}>
          Convert
        </button>
      </Form>
    </div>
  );
};

export default AraiMfgQuoationConversion;
